/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import classNames from 'classnames';
import FalconCardHeader from 'components/common/FalconCardHeader';
import ChartDownloadButton from './ChartDownloadButton';
import { isEmpty } from 'lodash';
import { FiInfo } from 'react-icons/fi';
import Model from './Model';
import SeasonalBarBody from './SeasonalBarBody';

const MultiYearBarChart = ({ data }) => {
  const [selectedYear, setSelectedYear] = useState(data?.variant[0] || null);
  const [filteredData, setFilteredData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedLegend, setSelectedLegend] = useState(null);
  const [desc, setDesc] = useState('');

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  useEffect(() => {
    if (selectedYear) {
      const selectedYearData = data?.data[selectedYear];
      const filteredYearData = {
        year: selectedYear,
        data: selectedYearData,
        series: data.series,
        unit: data.unit
      };

      // Set the filtered data
      setFilteredData(filteredYearData);
    }
  }, [selectedYear, data]);

  const handleSelectChange = e => {
    setSelectedYear(e.target.value);
  };

  const handleLegendSelect = legend => {
    setSelectedLegend(legend);
    setDesc(data.info[legend] || '');
  };

  return (
    <Card className={classNames('h-100', 'overflow-hidden')}>
      <FalconCardHeader
        title={data?.label}
        titleTag="h5"
        light={true}
        desc={data?.desc}
        endEl={
          data?.variant?.length > 1 && (
            <Row className="align-items-center">
              <Col xs={8} className="ps-2 py-0">
                <Form.Select
                  className="ps-2 py-0"
                  value={selectedYear}
                  onChange={handleSelectChange}
                >
                  {data?.variant?.map(entry => (
                    <option key={entry} value={entry}>
                      {entry}
                    </option>
                  ))}
                </Form.Select>
              </Col>
              <Col xs={4} className="ps-2 py-0">
                {filteredData && filteredData != null && (
                  <ChartDownloadButton
                    key={data?.label}
                    chartData={Object.values(filteredData?.data)}
                    series={Object.keys(filteredData?.data)}
                    xAxis={filteredData?.series}
                    filename={`${data?.label}`}
                  />
                )}
              </Col>
            </Row>
          )
        }
        infoBtn={
          !isEmpty(data.description) && <FiInfo onClick={handleShowModal} />
        }
      />
      <Card.Body className="h-100 px-3" dir="ltr">
        {filteredData && (
          <React.Fragment>
            <p className="units-text">{filteredData.unit}</p>
            <SeasonalBarBody
              landCoverChartData={filteredData}
              onLegendSelect={handleLegendSelect}
            />
          </React.Fragment>
        )}
      </Card.Body>
      <Card.Footer>
        {desc ? (
          <h5 className="infrence-info">
            {selectedLegend}: {desc}
          </h5>
        ) : (
          <></>
        )}
      </Card.Footer>
      <Model
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        description={data?.description || {}}
        title={data?.label}
      />
    </Card>
  );
};

export default MultiYearBarChart;
